import React from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'

type alignment = 'left' | 'center' | 'right'
interface WidgetGalleryTitlePositioningProps {
    value: alignment
    onChange: (value: alignment) => void
}
export const WidgetGalleryTitlePositioning = ({ value, onChange }: WidgetGalleryTitlePositioningProps): JSX.Element => {
    return (
        <StyledWGTitlePositioning className={'WGTitlePositioning'}>
            <button
                className={`WGTitlePositioning__WGButton ${value === 'left' ? 'actionSelected' : ''}`}
                onClick={() => onChange('left')}
            >
                <i className={'WGTitlePositioning__WGButton__WGIcon fas fa-border-left'} />
                {i18n('Left')}
            </button>
            <button
                className={`WGTitlePositioning__WGButton ${value === 'center' ? 'actionSelected' : ''}`}
                onClick={() => onChange('center')}
            >
                <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: '8px' }}>
                    <svg
                        width="12px"
                        height="12px"
                        color={'#868695'}
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="border-center-v"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                        className="svg-inline--fa fa-border-center-v fa-w-14 fa-3x"
                    >
                        <path
                            fill="currentColor"
                            d="M448 272v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16zm0-96v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16zM384 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16zm64 320v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16zM288 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16zM96 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16zm256 224v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16zm-192 0v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16zm-96 0v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16zm0-96v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16zM0 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48zm448 416v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16zm-96 0v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16zm-192 0v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16zm-96 0v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16zm0-96v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16zM192 48v416a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16z"
                        ></path>
                    </svg>
                </span>
                {i18n('Center')}
            </button>
            <button
                className={`WGTitlePositioning__WGButton ${value === 'right' ? 'actionSelected' : ''}`}
                onClick={() => onChange('right')}
            >
                <i className={'WGTitlePositioning__WGButton__WGIcon fas fa-border-right'} />
                {i18n('Right')}
            </button>
        </StyledWGTitlePositioning>
    )
}

const StyledWGTitlePositioning = styled.div`
    display: flex;
    flex-direction: row;
    width: fit-content;

    .WGTitlePositioning {
        &__WGButton {
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 3px;
            width: max-content;
            height: 20px;
            font-style: normal;
            font-weight: normal;
            font-size: 13px;
            background-color: transparent;
            border-radius: 3px;
            outline: none;
            border: none;
            &:hover {
                background-color: #dddee1;
            }
            &__WGIcon {
                font-style: normal;
                font-weight: 900;
                font-size: 12px;
                margin-right: 8px;
                color: #868695;
            }
        }
    }
    .actionSelected {
        background: #dddee1;
    }
`
